import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'di-confirmation-dossier-patient',
  templateUrl: './confirmation-dossier-patient.component.html',
  styleUrls: ['./confirmation-dossier-patient.component.scss'],
})
export class ConfirmationDossierPatientComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {
	
  }
  @Input() confirm: Function;
  @Input() cancel: Function;

  onConfirm() {
    if(this.confirm) this.confirm();
  }

  onCancel() {
    if(this.cancel) this.cancel();
  }
}
